import React, { useContext, useEffect, useMemo, useState } from 'react'
import useMasterData from '../../Hooks/useMasterData';
import { AppContext } from '../../../AppContext';
import useStudentWorkingDays from '../../../libs/data-access/src/StudentWorkingDays/useStudentWorkingDays';
import { showToast } from '../../../utils/utility';
import { handleValidateStudentWorking } from '../Components/validation';

const useStudentWiseWorkingDays = () => {
  const {
          user
      }:any = useContext(AppContext);
    const {
          classesBasedOnSchool,
          getClassesBasedOnSchoolId,
          sectionBasedOnSchoolAndClass,
          getSectionBySchoolAndClassId
      } = useMasterData();

      const { fetchStudentWorkingData, postStudentWorkingDataData } =
        useStudentWorkingDays();

      const [attandanceDetails, setAttandanceDetails] = useState<any>({
        class_id :'',
        section_id:'',
        year:'',
        month:'13',
        total_working_days:'',
        students:[]
      })

const [loading,setLoading] = useState<any>(false)
const [loadingSave, setLoadingSave] = useState<any>(false);
const[students,setStudents] = useState<any>([])
const [editEnable, setEditEnable] = useState<any>(true)
 const getStudentDataApi = async () => {
    setLoading(true);
    const res = await fetchStudentWorkingData(
      `GetStudentDetailsByParm?UDISECode=${user?.details?.schoolUserDetails?.udisE_Code || 0}&ClassId=${attandanceDetails?.class_id || 0}&SectionId=${attandanceDetails?.section_id || 0}&Year=${attandanceDetails?.year || 0}&Months=${attandanceDetails?.month || 0}`,
    );
    if (res.isSuccess) {
      setStudents(res?.data);
    } else {
      setStudents([]);
      showToast({
        type: "error",
        message: res.message || "Something went wrong",
      });
    }

    setLoading(false);
  };

        // const calculatedStudents = useMemo(() => {
        //   const totalDays = Number(attandanceDetails?.total_working_days) || 0;
  
        //   return students.map((s: any) => {
        //     const presentDays = Number(s.presentDays) || 0;
        //     const clampedPresent = Math.min(presentDays, totalDays);
  
        //     const absent = totalDays - clampedPresent;
  
        //     const percentage =
        //       totalDays > 0 && clampedPresent > 0
        //         ? Number(((clampedPresent / totalDays) * 100).toFixed(2))
        //         : 0; // ✅ THIS fixes NaN%
  
        //     return {
        //       ...s,
        //       presentDays: clampedPresent,
        //       absent,
        //       percentage,
        //     };
        //   });
        // }, [students, attandanceDetails?.total_working_days]);
const [calculatedStudents, setCalculatedStudents] = useState<any>([])
const [isUserChange,setIsUserChange] = useState<any>(false)
               useEffect(() => {
                 const totalDays = Number(students[0]?.totalWorkingDays) || 0;

                 const updatedStudents = (students ?? []).map((s: any) => {
                   const presentDays = Number(s.presentDays) || 0;
                  //  const clampedPresent = presentDays;

                   const absent = totalDays > 0 ? totalDays - presentDays : 0;

                   const percentage =
                     totalDays > 0
                       ? Number(((presentDays / totalDays) * 100).toFixed(2))
                       : 0;

                   return {
                     ...s,
                     presentDays: presentDays,
                     absent,
                     percentage,
                   };
                 });

                 setCalculatedStudents(updatedStudents);
               }, [students]);

               useEffect(() => {
                if (students[0]?.totalWorkingDays>0) {
                  setAttandanceDetails((prev: any) => ({
                    ...prev,
                    total_working_days: students[0]?.totalWorkingDays,
                  }));
                  setEditEnable(false)
                }
               }, [students]);

               useEffect(() => {
                if(isUserChange){
                let student = calculatedStudents?.map((item:any)=>{
                  return {
                    ...item,
                    presentDays: 0,
                    absent:0,
                    percentage:0,
                  };
                })
                setCalculatedStudents(student);
                setIsUserChange(false);
              }
               }, [attandanceDetails?.total_working_days]);
               
               

        const updatePresentDays = (id: number, value: any) => {
          // if (typeof value !== "number") return;

          setCalculatedStudents((prev: any) =>
            prev.map((s: any) =>
              s.studentRegistrationNumber == id
                ? {
                    ...s,
                    presentDays: Math.min(
                      value,
                      attandanceDetails?.total_working_days,
                    ),
                    absent:
                      attandanceDetails?.total_working_days > 0
                        ? attandanceDetails?.total_working_days -
                          Math.min(value, attandanceDetails?.total_working_days)
                        : 0,
                    percentage: attandanceDetails?.total_working_days > 0
                       ? Number(((Math.min(value, attandanceDetails?.total_working_days) / attandanceDetails?.total_working_days) * 100).toFixed(2))
                       : 0,
                  }
                : s,
            ),
          );
        };
  const handleSaveAttendance = async () => {
    setLoadingSave(true)
    try {
      const payloadToValidate = {
        ...attandanceDetails,
        students: calculatedStudents.map((s: any) => ({
          student_id: s.id,
          present_days: s.presentDays,
        })),
      };

      // 🔐 Validate before save
      const isValid = handleValidateStudentWorking(payloadToValidate);
      if (!isValid) return;

      let PaylaodToSend = {
        schoolCode: user.details.schoolUserDetails?.school_Code,
        standardId: Number(attandanceDetails?.class_id),
        sectionId: Number(attandanceDetails?.section_id),
        year: Number(attandanceDetails?.year),
        months: Number(attandanceDetails?.month),
        totalWorkingDays: Number(attandanceDetails?.total_working_days),
        createdBy: String(user.user_Id),
        ipAddress: "",
        students: calculatedStudents.map((s: any) => ({
          studentRegistrationNumber: String(s.studentRegistrationNumber),
          presentDays: Number(s.presentDays),
        })),
      };

       const res = await postStudentWorkingDataData(
         `InsertSchoolWorkingDaysDetails`,
         PaylaodToSend,
       );

        if (res.isSuccess) {
           showToast({
             type: "success",
             message: "Attendance saved successfully",
           });
           getStudentDataApi()
        } else {
          showToast({
            type: "error",
            message: res.message || "Something went wrong",
          });
        }
    } catch (error: any) {
      console.error("Save attendance error:", error);

      showToast({
        type: "error",
        message:
          error?.message || "Something went wrong while saving attendance",
      });
    } finally{
      setLoadingSave(false)
    }
  };

      useEffect(() => {
        getClassesBasedOnSchoolId(user?.details?.schoolUserDetails?.school_Id);
      }, [])

      useEffect(() => {if (attandanceDetails?.class_id){
 getSectionBySchoolAndClassId(
   user.details.schoolUserDetails?.school_Id,
   attandanceDetails?.class_id,
 );
      }
       }, [attandanceDetails?.class_id]);

       const clearAll = () => {
        setEditEnable(true); 
        setCalculatedStudents([]);
        setAttandanceDetails((prev:any)=>{
          return {
            ...prev,
            total_working_days:''
          };
        })
       }
      
      
  return {
    classesBasedOnSchool,
    sectionBasedOnSchoolAndClass,
    attandanceDetails,
    setAttandanceDetails,
    getStudentDataApi,
    loading,
    students,
    setStudents,
    updatePresentDays,
    calculatedStudents,
    handleSaveAttendance,
    loadingSave,
    setIsUserChange,
    setCalculatedStudents,
    clearAll,
    setEditEnable,
    editEnable
  };
}

export default useStudentWiseWorkingDays